import dayjs from 'dayjs'
import { createProjectTypeDetails } from 'src/utils/miscellaneous'
import { projectTypes, quoteTypes } from 'src/utils/typeUtils'

export const sectionPdf = [
	{
		name: 'name',
		required: true,
	},
	{
		name: 'email',
		required: false,
	},
	{
		name: 'phone',
		required: false,
	},
	{
		name: 'website',
		required: false,
	},
	{
		name: 'registrationNumber',
		required: false,
	},
	{
		name: 'vatNumber',
		required: false,
	},
	{
		name: 'addressLine1',
		required: false,
	},
	{
		name: 'addressLine2',
		required: false,
	},
]

export const sectionBudgetTC = [
	// We removed these terms and conditions for photo and replaced by the s3 versions below in sectionQuoteTypeTC
	// {
	//   name: 'termsAndCondition1',
	//   required: false,
	// },
	// {
	//   name: 'termsAndCondition2',
	//   required: false,
	// },
	{
		name: 'termsAndCondition3',
		required: false,
	},
]
export const sectionQuoteTypeTC = [
	{
		name: 'frenchApfpTAndC1',
		required: false,
	},
	{
		name: 'frenchApfpTAndC2',
		required: false,
	},
	{
		name: 'editorialTAndC',
		required: false,
	},
	{
		name: 'editorialEnglishTAndC',
		required: false,
	},
	{
		name: 'commercialTAndC',
		required: false,
	},
	{
		name: 'commercialEnglishTAndC',
		required: false,
	},
	{
		name: 'setDesignTAndC',
		required: false,
	},
	{
		name: 'setDesignEnglishTAndC',
		required: false,
	},
	{
		name: 'wardrobeTAndC',
		required: false,
	},
	{
		name: 'wardrobeEnglishTAndC',
		required: false,
	},
	{
		name: 'digitalTAndC',
		required: false,
	},
	{
		name: 'animationTAndC',
		required: false,
	},
	{
		name: 'animationEnglishTAndC',
		required: false,
	},
	{
		name: 'soundProdTAndC1',
		required: false,
	},
	{
		name: 'soundProdTAndC2',
		required: false,
	},
	{
		name: 'blankQuoteTAndC',
		required: false,
	},
	{
		name: 'blankQuoteEnglishTAndC',
		required: false,
	},
	{ name: 'aicpTAndC', required: false },
]
export const sectionPOTC = [
	{
		name: 'poTANDC1',
		required: false,
	},
]
export const sectionCurrency = [
	{
		name: 'accountCurrency',
		required: true,
	},
]
export const sectionBankOne = [
	{
		name: 'bankProfileName',
		required: false,
	},
	{
		name: 'bank',
		required: false,
	},
	{
		name: 'iban',
		required: false,
	},
	{
		name: 'bic',
		required: false,
	},
	{
		name: 'accountName',
		required: false,
	},
]
export const sectionBankTwo = [
	{
		name: 'bankProfileName2',
		required: false,
	},
	{
		name: 'bank2',
		required: false,
	},
	{
		name: 'iban2',
		required: false,
	},
	{
		name: 'bic2',
		required: false,
	},
	{
		name: 'accountName2',
		required: false,
	},
]
export const sectionBankThree = [
	{
		name: 'bankProfileName3',
		required: false,
	},
	{
		name: 'bank3',
		required: false,
	},
	{
		name: 'iban3',
		required: false,
	},
	{
		name: 'bic3',
		required: false,
	},
	{
		name: 'accountName3',
		required: false,
	},
]
export const sectionBankFour = [
	{
		name: 'bankProfileName4',
		required: false,
	},
	{
		name: 'bank4',
		required: false,
	},
	{
		name: 'iban4',
		required: false,
	},
	{
		name: 'bic4',
		required: false,
	},
	{
		name: 'accountName4',
		required: false,
	},
]
export const sectionBankFive = [
	{
		name: 'bankProfileName5',
		required: false,
	},
	{
		name: 'bank5',
		required: false,
	},
	{
		name: 'iban5',
		required: false,
	},
	{
		name: 'bic5',
		required: false,
	},
	{
		name: 'accountName5',
		required: false,
	},
]
export const sectionAccParameters = [
	{
		name: 'country',
		required: true,
	},
	{
		name: 'specialFrenchInvoiceNote',
		required: false,
		defaultValue: `Conditions de paiement : Loi 92.1142 du 31/12/92, toutes nos factures sont payables à réception, net sans escompte sauf conditions particulières. Tout retard de paiement fera l'objet, de plein droit, d'intérêts calculés sur une base de 1.5 fois le taux d'intérêt légal en vigueur. TVA en sus. Il sera également du une indemnité forfaitaire pour frais de recouvrement de 40 euros conformément à l'article 121 de la loi du 22 mars 2012 et au décret du 2 octobre 2012 article D .441-5 du code du commerce.`,
	},
	{
		name: 'specialEnglishInvoiceNote',
		required: false,
		defaultValue:
			'Payment conditions: Law 92.1142 of 12/31/92, all our invoices are payable upon receipt, net without discount except under special conditions. Any late payment will automatically be subject to interest calculated on the basis of 1.5 times the legal interest rate in force. VAT not included. A lump sum indemnity for recovery costs of 40 euros will also be payable in accordance with article 121 of the law of March 22, 2012 and the decree of October 2, 2012, article D .441-5 of the commercial code.',
	},
	{
		name: 'createPurchaseRecap',
		required: true,
	},
	{
		name: 'paymentTerms',
		required: true,
	},
	{
		name: 'invoiceCount',
		required: true,
	},
	{
		name: 'invoiceNumberPrefix',
		required: true,
	},
	{
		name: 'poNumberPrefix',
		required: true,
	},
	{
		name: 'sendOverheadsToReviewPage',
		required: false,
	},
	{
		name: 'sendCostlinesToReviewPage',
		required: false,
	},
	{
		name: 'activateDeliveryDate',
		required: false,
	},
	{
		name: 'defaultProjectType',
		required: true,
	},
]
export const sectionApfpAccNos = [
	{
		name: 'local',
		required: false,
		nameValue: 'apfpLocalName',
		numberValue: 'apfpLocalNumber',
	},
	{
		name: 'EU',
		required: false,
		nameValue: 'apfpEUName',
		numberValue: 'apfpEUNumber',
	},
	{
		name: 'International',
		required: false,
		nameValue: 'apfpInternationalName',
		numberValue: 'apfpInternationalNumber',
	},
]
export const sectionAicpAccNos = [
	{
		name: 'local',
		required: false,
		nameValue: 'aicpLocalName',
		numberValue: 'aicpLocalNumber',
	},
	{
		name: 'EU',
		required: false,
		nameValue: 'aicpEUName',
		numberValue: 'aicpEUNumber',
	},
	{
		name: 'International',
		required: false,
		nameValue: 'aicpInternationalName',
		numberValue: 'aicpInternationalNumber',
	},
]
export const sectionPhotoAccNos = [
	{
		name: 'local',
		required: false,
		nameValue: 'photoLocalName',
		numberValue: 'photoLocalNumber',
	},
	{
		name: 'EU',
		required: false,
		nameValue: 'photoEUName',
		numberValue: 'photoEUNumber',
	},
	{
		name: 'International',
		required: false,
		nameValue: 'photoInternationalName',
		numberValue: 'photoInternationalNumber',
	},
]
export const sectionPostProdAccNos = [
	{
		name: 'local',
		required: false,
		nameValue: 'postProdLocalName',
		numberValue: 'postProdLocalNumber',
	},
	{
		name: 'EU',
		required: false,
		nameValue: 'postProdEUName',
		numberValue: 'postProdEUNumber',
	},
	{
		name: 'International',
		required: false,
		nameValue: 'postProdInternationalName',
		numberValue: 'postProdInternationalNumber',
	},
]
export const sectionVatAccount = [
	{
		name: 'vat20',
		required: false,
		numberValue: 'vat20',
	},
	{
		name: 'vat10',
		required: false,
		numberValue: 'vat10',
	},
]
export const sectionCostVAT = [
	{
		name: 'vatAccount',
		required: false,
		defaultValue: '445660-TVA sur autres biens et services',
	},
]
export const sectionMiscAccNos = [
	{
		name: 'miscAccNosFields',
		required: false,
		// defaultValue: '445660-TVA sur autres biens et services',
	},
]
export const sectionCostVATIntracom = [
	{
		name: 'eu',
		required: false,
		debitNumber: 'euDebitNumber',
		debitName: 'euDebitName',
		creditNumber: 'euCreditNumber',
		creditName: 'euCreditName',
		defaultDebitNumber: '445662',
		defaultDebitName: 'TVA déductible (UE)',
		defaultCreditNumber: '445200',
		defaultCreditName: 'TVA collectée 20% (UE)',
	},
	{
		name: 'intl',
		required: false,
		debitNumber: 'intlDebitNumber',
		debitName: 'intlDebitName',
		creditNumber: 'intlCreditNumber',
		creditName: 'intlCreditName',
		defaultDebitNumber: '445663',
		defaultDebitName: 'TVA déductible (hors UE)',
		defaultCreditNumber: '445713',
		defaultCreditName: 'TVA collectée 20% (hors UE)',
	},
]
export const sectionCostAccNos = [
	{
		name: 'costAccountNumbers',
		required: false,
	},
]
export const prefixForSubAcc = [
	{
		name: 'clientsSubAcc',
		required: false,
		defaultValue: 9,
	},
	{
		name: 'suppliersSubAcc',
		required: false,
		defaultValue: 0,
	},
	{
		name: 'individualSuppliersSubAcc',
		required: false,
		defaultValue: 467,
	},
]

export const sectionProjectDetails = [
	{
		type: 'frenchApfp',
		required: true,
		name: 'frenchApfpName',
		count: 'frenchApfpCount',
	},
	{
		type: 'frenchPostProd',
		required: true,
		name: 'frenchPostProdName',
		count: 'frenchPostProdCount',
	},
	{
		type: 'aicp',
		required: true,
		name: 'aicpName',
		count: 'aicpCount',
	},
	{
		type: 'photoGrid',
		required: true,
		name: 'photoGridName',
		count: 'photoGridCount',
	},
	{
		type: 'soundProd',
		required: true,
		name: 'soundProdName',
		count: 'soundProdCount',
	},
	{
		type: 'cnc5ch',
		required: true,
		name: 'cnc5chName',
		count: 'cnc5chCount',
	},
	{
		type: 'quoteDigital',
		required: true,
		name: 'quoteDigitalName',
		count: 'quoteDigitalCount',
	},
	{
		type: 'quoteAnimationAndLiveAction',
		required: true,
		name: 'quoteAnimationAndLiveActionName',
		count: 'quoteAnimationAndLiveActionCount',
	},
	{
		type: 'quoteAnimationOnly',
		required: true,
		name: 'quoteAnimationOnlyName',
		count: 'quoteAnimationOnlyCount',
	},
]
export const sectionProjectGroupDetails = projectTypes.map((pt) => {
	const obj = {
		type: pt,
		required: true,
		name: `${pt}Name`,
		count: `${pt}Count`,
	}
	return obj
})

export const singleProjectId = [
	{ name: 'useOneProjectNumber', required: true },
	{ name: 'commonProjectNumber', required: true },
]
export const commonProjectGroupCustomization = [
	{ name: 'commonProjectGroupFlag', required: false, defaultValue: false },
	{ name: 'commonProjectGroup', required: false, defaultValue: 'other' },
	{ name: 'restrictProjectGroup', required: false, defaultValue: false },
]
export const customizeProjectDetails = [
	{ name: 'seperator', required: true },
	{ name: 'first', required: true },
	{ name: 'second', required: true },
	{ name: 'third', required: true },
]
export const sectionQuoteGroupDetails = quoteTypes.map((pt) => {
	const obj = {
		type: pt,
		required: true,
		name: `${pt}Name`,
		count: `${pt}Count`,
	}
	return obj
})

export const singleQuoteId = [
	{ name: 'useOneQuoteNumber', required: true },
	{ name: 'commonQuoteNumber', required: true },
]
export const customizeQuoteDetails = [
	{ name: 'quoteseperator', required: true },
	{ name: 'quotefirst', required: true },
	{ name: 'quotesecond', required: true },
	{ name: 'quotethird', required: true },
]

export const salesAccountByQuoteType = [
	{
		frenchApfp: [
			{
				name: 'Local',
				required: false,
				nameValue: 'frenchApfpLocalName',
				numberValue: 'frenchApfpLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'frenchApfpEUName',
				numberValue: 'frenchApfpEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'frenchApfpInternationalName',
				numberValue: 'frenchApfpInternationalNumber',
			},
		],
		frenchPostProd: [
			{
				name: 'Local',
				required: false,
				nameValue: 'frenchPostProdLocalName',
				numberValue: 'frenchPostProdLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'frenchPostProdEUName',
				numberValue: 'frenchPostProdEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'frenchPostProdInternationalName',
				numberValue: 'frenchPostProdInternationalNumber',
			},
		],
		aicp: [
			{
				name: 'Local',
				required: false,
				nameValue: 'aicpLocalName',
				numberValue: 'aicpLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'aicpEUName',
				numberValue: 'aicpEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'aicpInternationalName',
				numberValue: 'aicpInternationalNumber',
			},
		],
		photoGrid: [
			{
				name: 'Local',
				required: false,
				nameValue: 'photoGridLocalName',
				numberValue: 'photoGridLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'photoGridEUName',
				numberValue: 'photoGridEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'photoGridInternationalName',
				numberValue: 'photoGridInternationalNumber',
			},
		],
		soundProd: [
			{
				name: 'Local',
				required: false,
				nameValue: 'soundProdLocalName',
				numberValue: 'soundProdLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'soundProdEUName',
				numberValue: 'soundProdEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'soundProdInternationalName',
				numberValue: 'soundProdInternationalNumber',
			},
		],
		cnc5ch: [
			{
				name: 'Local',
				required: false,
				nameValue: 'cnc5chLocalName',
				numberValue: 'cnc5chLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'cnc5chEUName',
				numberValue: 'cnc5chEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'cnc5chInternationalName',
				numberValue: 'cnc5chInternationalNumber',
			},
		],
		quoteDigital: [
			{
				name: 'Local',
				required: false,
				nameValue: 'quoteDigitalLocalName',
				numberValue: 'quoteDigitalLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'quoteDigitalEUName',
				numberValue: 'quoteDigitalEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'quoteDigitalInternationalName',
				numberValue: 'quoteDigitalInternationalNumber',
			},
		],
		quoteAnimationAndLiveAction: [
			{
				name: 'Local',
				required: false,
				nameValue: 'quoteAnimationAndLiveActionLocalName',
				numberValue: 'quoteAnimationAndLiveActionLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'quoteAnimationAndLiveActionEUName',
				numberValue: 'quoteAnimationAndLiveActionEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'quoteAnimationAndLiveActionInternationalName',
				numberValue: 'quoteAnimationAndLiveActionInternationalNumber',
			},
		],
		quoteAnimationOnly: [
			{
				name: 'Local',
				required: false,
				nameValue: 'quoteAnimationOnlyLocalName',
				numberValue: 'quoteAnimationOnlyLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'quoteAnimationOnlyEUName',
				numberValue: 'quoteAnimationOnlyEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'quoteAnimationOnlyInternationalName',
				numberValue: 'quoteAnimationOnlyInternationalNumber',
			},
		],
		'360Template': [
			{
				name: 'Local',
				required: false,
				nameValue: '360TemplateLocalName',
				numberValue: '360TemplateLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: '360TemplateEUName',
				numberValue: '360TemplateEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: '360TemplateInternationalName',
				numberValue: '360TemplateInternationalNumber',
			},
		],
	},
]

export const salesAccountByCostline = [
	{
		servicesProvided20: [
			{
				name: 'Local',
				required: false,
				nameValue: 'servicesProvided20LocalName',
				numberValue: 'servicesProvided20LocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'servicesProvided20EUName',
				numberValue: 'servicesProvided20EUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'servicesProvided20InternationalName',
				numberValue: 'servicesProvided20InternationalNumber',
			},
		],
		publishingRights10: [
			{
				name: 'Local',
				required: false,
				nameValue: 'publishingRights10LocalName',
				numberValue: 'publishingRights10LocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'publishingRights10EUName',
				numberValue: 'publishingRights10EUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'publishingRights10InternationalName',
				numberValue: 'publishingRights10InternationalNumber',
			},
		],
		masterRights20: [
			{
				name: 'Local',
				required: false,
				nameValue: 'masterRights20LocalName',
				numberValue: 'masterRights20LocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'masterRights20EUName',
				numberValue: 'masterRights20EUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'masterRights20InternationalName',
				numberValue: 'masterRights20InternationalNumber',
			},
		],
		billOfRights10: [
			{
				name: 'Local',
				required: false,
				nameValue: 'billOfRights10LocalName',
				numberValue: 'billOfRights10LocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'billOfRights10EUName',
				numberValue: 'billOfRights10EUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'billOfRights10InternationalName',
				numberValue: 'billOfRights10InternationalNumber',
			},
		],
		billOfRights20: [
			{
				name: 'Local',
				required: false,
				nameValue: 'billOfRights20LocalName',
				numberValue: 'billOfRights20LocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'billOfRights20EUName',
				numberValue: 'billOfRights20EUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'billOfRights20InternationalName',
				numberValue: 'billOfRights20InternationalNumber',
			},
		],
		rightMusic: [
			{
				name: 'Local',
				required: false,
				nameValue: 'rightMusicLocalName',
				numberValue: 'rightMusicLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'rightMusicEUName',
				numberValue: 'rightMusicEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'rightMusicInternationalName',
				numberValue: 'rightMusicInternationalNumber',
			},
		],
		copyRightAndReproduction: [
			{
				name: 'Local',
				required: false,
				nameValue: 'copyRightAndReproductionLocalName',
				numberValue: 'copyRightAndReproductionLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'copyRightAndReproductionEUName',
				numberValue: 'copyRightAndReproductionEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'copyRightAndReproductionInternationalName',
				numberValue: 'copyRightAndReproductionInternationalNumber',
			},
		],

		servicesProvided10: [
			{
				name: 'Local',
				required: false,
				nameValue: 'servicesProvided10LocalName',
				numberValue: 'servicesProvided10LocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'servicesProvided10EUName',
				numberValue: 'servicesProvided10EUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'servicesProvided10InternationalName',
				numberValue: 'servicesProvided10InternationalNumber',
			},
		],

		synchroTradingService: [
			{
				name: 'Local',
				required: false,
				nameValue: 'synchroTradingServiceLocalName',
				numberValue: 'synchroTradingServiceLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'synchroTradingServiceEUName',
				numberValue: 'synchroTradingServiceEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'synchroTradingServiceInternationalName',
				numberValue: 'synchroTradingServiceInternationalNumber',
			},
		],

		tradingService: [
			{
				name: 'Local',
				required: false,
				nameValue: 'tradingServiceLocalName',
				numberValue: 'tradingServiceLocalNumber',
			},
			{
				name: 'EU',
				required: false,
				nameValue: 'tradingServiceEUName',
				numberValue: 'tradingServiceEUNumber',
			},
			{
				name: 'International',
				required: false,
				nameValue: 'tradingServiceInternationalName',
				numberValue: 'tradingServiceInternationalNumber',
			},
		],
	},
]

export const clientSAN = [
	{
		name: 'clientsSalesAccountNumber',
		required: true,
		defaultValue: '411000',
	},
]
export const suppliersCAN = [
	{
		name: 'suppliersCostAccountNumber',
		required: true,
		defaultValue: '401000',
	},
]
export const ledgerName = [
	{
		name: 'salesLedgerName',
		required: true,
		defaultValue: 'VT',
	},
	{
		name: 'purchasesLedgerName',
		required: true,
		defaultValue: 'AC',
	},
	// {
	//   name: 'bank1LedgerName',
	//   required: false,
	// },
	// {
	//   name: 'bank2LedgerName',
	//   required: false,
	// },
	// {
	//   name: 'bank3LedgerName',
	//   required: false,
	// },
]

export const emailTemplates = [
	{
		id: 'Template 1',
		required: true,
		language: 'fr',
		name: 'Envoie d’une facture',
		subject:
			'Votre facture {{companyName}} - {{companyEmail}} N° {{invoiceNumber}} est disponible',
		body: "Bonjour,\n\nVoici votre dernière facture de l'entreprise {{companyName}} - {{companyEmail}}.\nCette facture N° {{invoiceNumber}} d'un montant de {{totalAmount}} est payable par virement bancaire avant le {{invoiceDueDate}}.\n\nMerci d'inclure la référence de paiement {{invoiceNumber}} dans le libellé de votre virement.\n\nMerci de votre confiance !",
	},
	{
		id: 'Template 2',
		required: true,
		language: 'en',
		name: 'Sending Invoice',
		subject:
			'Your invoice {{companyName}} - {{companyEmail}} N° {{invoiceNumber}} is available',
		body: "Hello,\n\nHere's your last bill of the company {{companyName}} - {{companyEmail}}.\nThis invoice No. {{invoiceNumber}} of {{totalAmount}} is payable by bank transfer before the {{invoiceDueDate}}.\n\nPlease include the payment reference {{invoiceNumber}} in the wording of your transfer.\n\nThank you for your confidence!",
	},
	{
		id: 'Template 3',
		required: true,
		language: 'fr',
		name: 'Séquence de relance par défaut-J-2',
		subject: 'Votre facture {{companyName}} arrive bientôt à échéance',
		body: "Bonjour,\n\nNous vous rappelons que la facture de l'entreprise {{companyName}} arrive bientôt à échéance.\nCette facture N° {{invoiceNumber}} d'un montant de {{totalAmount}} est payable par virement bancaire avant le {{invoiceDueDate}}.\nMerci d'inclure la référence {{invoiceNumber}} dans le libellé de votre virement.\n\nSi vous avez déjà réglé cette facture, merci d'ignorer cet email.\n\nA bientôt,",
	},
	{
		id: 'Template 4',
		required: true,
		language: 'en',
		name: 'Default reminder sequence-D-2',
		subject: 'Your {{companyName}} invoice is due soon',
		body: 'Hello,\n\nWe remind you that the invoice of the company {{companyName}} is due soon.\nThis invoice No. {{invoiceNumber}} for an amount of {{totalAmount}} is payable by bank transfer before {{invoiceDueDate}}.\nPlease include the reference {{invoiceNumber}} in the wording of your transfer.\n\nIf you have already paid this invoice, please ignore this email.\n\nBest regards,',
	},
	{
		id: 'Template 5',
		required: true,
		language: 'fr',
		name: 'Séquence de relance par défaut-J+1',
		subject: 'Votre facture {{companyName}} est arrivée à échéance',
		body: "Bonjour,\n\nSauf erreur de notre part, la facture N°{{invoiceNumber}} d'un montant de {{totalAmount}} n'a pas été réglée.\nCette facture est payable par virement bancaire.\nMerci d'inclure la référence {{invoiceNumber}} dans le libellé de votre virement.\n\nSi vous avez déjà réglé cette facture, merci d'ignorer cet email.\n\nA bientôt,",
	},
	{
		id: 'Template 6',
		required: true,
		language: 'en',
		name: 'Default reminder sequence-D+1',
		subject: 'Your {{companyName}} invoice is due',
		body: 'Hello,\n\nUnless we are mistaken, invoice No. {{invoiceNumber}} for an amount of {{totalAmount}} has not been paid.\nThis invoice is payable by bank transfer.\nPlease include the reference {{invoiceNumber}} in the wording of your transfer.\n\nIf you have already paid this invoice, please ignore this email.\n\nBest regards,',
	},
	{
		id: 'Template 7',
		required: true,
		language: 'fr',
		name: 'Séquence de relance par défaut-J+7',
		subject: 'Votre facture {{companyName}} est en retard de 7 jours',
		body: "Bonjour,\n\nSauf erreur de notre part, la facture N°{{invoiceNumber}} d'un montant de {{totalAmount}} dont la date d'échéance était au {{invoiceDueDate}} n'a pas été réglée.\nCette facture est payable par virement bancaire.\nMerci d'inclure la référence {{invoiceNumber}} dans le libellé de votre virement.\n\nSi vous avez déjà réglé cette facture, merci d'ignorer cet email.\n\nA bientôt,",
	},
	{
		id: 'Template 8',
		required: true,
		language: 'en',
		name: 'Default reminder sequence-D+7',
		subject: 'Your {{companyName}} invoice is 7 days late',
		body: 'Hello,\n\nUnless we are mistaken, invoice No. {{invoiceNumber}} for an amount of {{totalAmount}} with a due date of {{invoiceDueDate}} has not been paid.\nThis invoice is payable by bank transfer.\nPlease include the reference {{invoiceNumber}} in the wording of your transfer.\n\nIf you have already paid this invoice, please ignore this email.\n\nBest regards`',
	},
]

export const billitFields = [
	{
		name: 'billitPartyId',
		required: false,
		defaultValue: '',
	},
	{
		name: 'billitApiKey',
		required: false,
		defaultValue: '',
	},
]

const projectGroupCountArray = projectTypes.map((pt) => {
	const { newName, newTypeDetails } = createProjectTypeDetails(pt)
	const projectTypeDetails = newTypeDetails
	return projectTypeDetails
})
export const defaultValuesForCompanyTable = [
	{
		name: 'emailTemplateArray',
		value: emailTemplates?.map((e) => {
			return {
				id: e.id,
				language: e.language,
				name: e.name,
				subject: e.subject,
				body: e.body,
			}
		}),
	},
	{ name: 'invoiceNumberPrefix', value: 'INV' },
	{ name: 'poNumberPrefix', value: 'PO' },
	{ name: 'clientsSalesAccountNumber', value: '411000' },
	{ name: 'suppliersCostAccountNumber', value: '401000' },
	{ name: 'invoiceCount', value: 0 },
	{ name: 'invoicingYear', value: dayjs().toISOString() },
	{ name: 'salesLedgerName', value: 'VT' },
	{ name: 'purchasesLedgerName', value: 'AC' },
	{
		name: 'quoteNumberCustomisation',
		value: [
			{
				seperator: ',',
				first: 'name',
				second: 'YYYY',
				third: 'number',
			},
		],
	},
	{ name: 'commonQuoteNumber', value: 1 },
	{ name: 'useOneQuoteNumber', value: true },
	{
		name: 'projectNumberCustomisation',
		value: [
			{
				seperator: ',',
				first: 'name',
				second: 'YYYY',
				third: 'number',
			},
		],
	},
	{ name: 'commonProjectNumber', value: 1 },
	{ name: 'useOneProjectNumber', value: true },
	{ name: 'country', value: 'France' },
	{ name: 'paymentTerms', value: 'net60' },
	{ name: 'accountCurrency', value: 'EUR' },
	{ name: 'vat20', value: '445720' },
	{ name: 'vat10', value: '445710' },
	{ name: 'taxRateType', value: true },
	{ name: 'salesAccNumberType', value: 'quoteType' },
	{ name: 'projectGroupCount', value: projectGroupCountArray },
	{
		name: 'sendOverheadsToReviewPage',
		value: 'send',
	},
	{
		name: 'sendCostlinesToReviewPage',
		value: 'send',
	},
	{
		name: 'activateDeliveryDate',
		value: 'no',
	},
	{
		name: 'defaultProjectType',
		value: 'frenchApfp',
	},
	{
		name: 'salesAccQuoteTypeDetails',
		value: [
			{
				type: 'frenchApfp',
				EUName: 'PRESTATIONS UE-FILMS',
				EUNumber: '7062000000',
				InternationalName: 'PRESTATIONS EXPORT-FILMS',
				InternationalNumber: '7069000000',
				LocalName: 'PRESTATIONS 20%-FILMS',
				LocalNumber: '7061000000',
			},
			{
				type: 'frenchPostProd',
				EUName: 'PRESTATIONS UE-POST',
				EUNumber: '7062020000',
				InternationalName: 'PRESTATIONS EXPORT-POST',
				InternationalNumber: '7069020000',
				LocalName: 'PRESTATIONS 20%-POST',
				LocalNumber: '7061020000',
			},
			{
				type: 'aicp',
				EUName: 'PRESTATIONS UE-FILMS',
				EUNumber: '7062000000',
				InternationalName: 'PRESTATIONS EXPORT-FILMS',
				InternationalNumber: '7069000000',
				LocalName: 'PRESTATIONS 20%-FILMS',
				LocalNumber: '7061000000',
			},
			{
				type: 'photoGrid',
				EUName: 'PRESTATIONS UE-IMAGE',
				EUNumber: '7062010000',
				InternationalName: 'PRESTATIONS EXPORT-IMAGE',
				InternationalNumber: '7069010000',
				LocalName: 'PRESTATIONS 20%-IMAGE',
				LocalNumber: '7061010000',
			},
			{
				type: 'soundProd',
				EUName: 'Prestations UE-Son',
				EUNumber: '7062030000',
				InternationalName: 'Prestations Export-Son',
				InternationalNumber: '7069030000',
				LocalName: 'Prestations Son',
				LocalNumber: '7061030000',
			},
			{
				type: 'quoteDigital',
				EUName: 'Prestations UE-Digital',
				EUNumber: '7062040000',
				InternationalName: 'Prestations Export-Digital',
				InternationalNumber: '7069040000',
				LocalName: 'Prestations Digital',
				LocalNumber: '7061040000',
			},
			{
				type: 'quoteAnimationAndLiveAction',
				EUName: 'Prestations UE-AnimeLive',
				EUNumber: '7062050000',
				InternationalName: 'Prestations Export-AnimeLive',
				InternationalNumber: '7069050000',
				LocalName: 'Prestations AnimeLive',
				LocalNumber: '7061050000',
			},
			{
				type: 'quoteAnimationOnly',
				EUName: 'Prestations UE-Animation',
				EUNumber: '7062060000',
				InternationalName: 'Prestations Export-Animation',
				InternationalNumber: '7069060000',
				LocalName: 'Prestations Animation',
				LocalNumber: '7061060000',
			},
			{
				type: 'cnc5ch',
				EUName: 'PRESTATIONS UE-FILMS',
				EUNumber: '7062080000',
				InternationalName: 'PRESTATIONS EXPORT-FILMS',
				InternationalNumber: '7069080000',
				LocalName: 'PRESTATIONS 20%-FILMS',
				LocalNumber: '7061080000',
			},
			{
				type: '360Template',
				EUName: 'PRESTATIONS UE-FILMS',
				EUNumber: '7062070000',
				InternationalName: 'PRESTATIONS EXPORT-FILMS',
				InternationalNumber: '7069070000',
				LocalName: 'PRESTATIONS 20%-FILMS',
				LocalNumber: '7061070000',
			},
		],
	},
	{
		name: 'quoteCount',
		value: [
			{
				count: 0,
				name: 'Estimate',
				type: 'frenchApfp',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'frenchPostProd',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'aicp',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'photoGrid',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'soundProd',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'cnc5ch',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'quoteAnimationAndLiveAction',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'quoteAnimationOnly',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'quoteDigital',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: '360Template',
				year: '2023-01-01T10:48:44.670Z',
			},
			{
				count: 0,
				name: 'Estimate',
				type: 'blankQuote',
				year: '2023-01-01T10:48:44.670Z',
			},
		],
	},
	{
		name: 'vatIntracom',
		value: [
			{
				type: 'eu',
				debitNumber: '445662',
				debitName: 'TVA déductible (UE)',
				creditNumber: '445200',
				creditName: 'TVA collectée 20% (UE)',
			},
			{
				type: 'intl',
				debitNumber: '445663',
				debitName: 'TVA déductible (hors UE)',
				creditNumber: '445713',
				creditName: 'TVA collectée 20% (hors UE)',
			},
		],
	},

	{
		name: 'specialEnglishInvoiceNote',
		value: 'Payment conditions: Law 92.1142 of 12/31/92, all our invoices are payable upon receipt, net without discount except under special conditions. Any late payment will automatically be subject to interest calculated on the basis of 1.5 times the legal interest rate in force. VAT not included. A lump sum indemnity for recovery costs of 40 euros will also be payable in accordance with article 121 of the law of March 22, 2012 and the decree of October 2, 2012, article D .441-5 of the commercial code.',
	},
	{
		name: 'specialFrenchInvoiceNote',
		value: `Conditions de paiement : Loi 92.1142 du 31/12/92, toutes nos factures sont payables à réception, net sans escompte sauf conditions particulières. Tout retard de paiement fera l'objet, de plein droit, d'intérêts calculés sur une base de 1.5 fois le taux d'intérêt légal en vigueur. TVA en sus. Il sera également du une indemnité forfaitaire pour frais de recouvrement de 40 euros conformément à l'article 121 de la loi du 22 mars 2012 et au décret du 2 octobre 2012 article D .441-5 du code du commerce.`,
	},
	{
		name: 'localOtNumberOfHours',
		value: 8,
	},
	{
		name: 'exeOtNumberOfHours',
		value: 8,
	},

	{
		name: 'clientsSubAcc',
		value: 9,
	},
	{
		name: 'suppliersSubAcc',
		value: 0,
	},
	{
		name: 'individualSuppliersSubAcc',
		value: 467,
	},
]

export const defaultAccNosForQuote = [
	{
		type: 'frenchApfp',
		EUName: 'PRESTATIONS UE-FILMS',
		EUNumber: '7062000000',
		InternationalName: 'PRESTATIONS EXPORT-FILMS',
		InternationalNumber: '7069000000',
		LocalName: 'PRESTATIONS 20%-FILMS',
		LocalNumber: '7061000000',
	},
	{
		type: 'frenchPostProd',
		EUName: 'PRESTATIONS UE-POST',
		EUNumber: '7062020000',
		InternationalName: 'PRESTATIONS EXPORT-POST',
		InternationalNumber: '7069020000',
		LocalName: 'PRESTATIONS 20%-POST',
		LocalNumber: '7061020000',
	},
	{
		type: 'aicp',
		EUName: 'PRESTATIONS UE-FILMS',
		EUNumber: '7062000000',
		InternationalName: 'PRESTATIONS EXPORT-FILMS',
		InternationalNumber: '7069000000',
		LocalName: 'PRESTATIONS 20%-FILMS',
		LocalNumber: '7061000000',
	},
	{
		type: 'photoGrid',
		EUName: 'PRESTATIONS UE-IMAGE',
		EUNumber: '7062010000',
		InternationalName: 'PRESTATIONS EXPORT-IMAGE',
		InternationalNumber: '7069010000',
		LocalName: 'PRESTATIONS 20%-IMAGE',
		LocalNumber: '7061010000',
	},
	{
		type: 'soundProd',
		EUName: 'Prestations UE-Son',
		EUNumber: '7062030000',
		InternationalName: 'Prestations Export-Son',
		InternationalNumber: '7069030000',
		LocalName: 'Prestations Son',
		LocalNumber: '7061030000',
	},
	{
		type: 'quoteDigital',
		EUName: 'Prestations UE-Digital',
		EUNumber: '7062040000',
		InternationalName: 'Prestations Export-Digital',
		InternationalNumber: '7069040000',
		LocalName: 'Prestations Digital',
		LocalNumber: '7061040000',
	},
	{
		type: 'quoteAnimationAndLiveAction',
		EUName: 'Prestations UE-AnimeLive',
		EUNumber: '7062050000',
		InternationalName: 'Prestations Export-AnimeLive',
		InternationalNumber: '7069050000',
		LocalName: 'Prestations AnimeLive',
		LocalNumber: '7061050000',
	},
	{
		type: 'quoteAnimationOnly',
		EUName: 'Prestations UE-Animation',
		EUNumber: '7062060000',
		InternationalName: 'Prestations Export-Animation',
		InternationalNumber: '7069060000',
		LocalName: 'Prestations Animation',
		LocalNumber: '7061060000',
	},
]
